const CSRF_COOKIE = "ps_csrf";

function getCookie(name: string): string {
  const parts = document.cookie.split(";").map((p) => p.trim());
  for (const p of parts) {
    if (p.startsWith(name + "=")) return decodeURIComponent(p.slice(name.length + 1));
  }
  return "";
}

export function getCsrfToken(): string {
  return getCookie(CSRF_COOKIE) || "";
}

// Centralized fetch wrapper: cookie auth + CSRF header on state-changing requests.
export async function apiFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const opts: RequestInit = { ...options };
  opts.credentials = "include";
  opts.cache = "no-store";

  const method = (opts.method || "GET").toString().toUpperCase();
  const isWrite = ["POST", "PUT", "PATCH", "DELETE"].includes(method);

  opts.headers = opts.headers ? { ...(opts.headers as Record<string, string>) } : {};

  if (isWrite) {
    const csrf = getCsrfToken();
    if (csrf) (opts.headers as Record<string, string>)["X-CSRF-Token"] = csrf;
  }

  try {
    return await fetch(url, opts);
  } catch (e) {
    console.log(e, opts);
    throw e;
  }
}
